import { omit } from 'lodash';
import { action, extendObservable } from 'mobx';
import FormService from '../../../core/services/FormService';
import FetchService from '../../../core/services/FetchService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';

class InstructionVideoListService {
  form = new FormService();
  fetch = new FetchService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      items: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
    });
  }

  init = action((initialFilters) => {
    this.items = [];
    this.form.setInitialValues({ ...initialFilters, type: 'ALL' } || { type: 'ALL' });
    this.handleLoad();
  });

  handleLoad = action(() => {
    const filtersData =
      this.form.getValue('type') === 'ALL' ? omit(this.form.getValues(), 'type') : this.form.getValues();

    this.fetch
      .fetch({
        url: '/instruction-videos',
        query: {
          page: this.pagination.current,
          size: this.pagination.pageSize,
          ...filtersData,
        },
      })
      .then(() => {
        if (this.fetch.data) {
          this.items = this.fetch.data.docs;
          this.pagination.total = this.fetch.data.total;
        } else {
          this.items = [];
          this.pagination.total = 0;
        }
      });
  });

  handleRemove = action((row) => {
    ConfirmationDialogService.show(
      'Delete Instruction Video',
      `You are about to delete the Instruction Video "${row.key}", Do you want to continue?`,
      () => {
        this.submit
          .fetch({
            url: `/instruction-videos/${row.id}`,
            method: 'delete',
          })
          .then(() => {
            if (this.submit.data) {
              NotificationService.addNotification(`Instruction Video "${row.key}" deleted successfully.`, 'success');
              this.handleLoad();
            }
            if (this.submit.error) {
              NotificationService.addNotification(`Error deleting Instruction Video.`, 'error');
            }
          });
      }
    );
  });
}

const instructionVideoListService = new InstructionVideoListService();
export default instructionVideoListService;
